import Select, { MultiValue } from "react-select";
import styled from "styled-components";
import { useQuery } from "@tanstack/react-query";
import { useReactSelectTheme } from "@bagel-web/components";

import { fetchMessageTypesCallback } from "../types";
import { messageTypeQueries } from "../queries";
import { decodeFilterOptions } from "./filterOptions";

export type MessageTypeSelectProps = {
  value: string | null;
  onChange: (e: { target: { value: string } }) => void;
  autoFocus?: boolean;
  // Fetches the message types available to the current user. The backend
  // decides which types (and whether the experimental group) are returned.
  fetchMessageTypes: fetchMessageTypesCallback;
};

const toOption = (name: string) => ({ value: name, label: name });

// The backend returns a machine-readable `group`; the UI owns the display
// language. The base group renders without a header (undefined label).
const GROUP_LABELS: Record<string, string | undefined> = {
  experimental: "Experimental",
};

const SelectContainer = styled.div`
  width: 400px;
`;

const MessageTypeSelect = ({
  value,
  onChange,
  autoFocus,
  fetchMessageTypes,
}: MessageTypeSelectProps) => {
  const { data, isPending } = useQuery({
    queryKey: messageTypeQueries.list(),
    queryFn: fetchMessageTypes,
    staleTime: Infinity,
  });

  const options = (data?.groups ?? []).map((group) => ({
    label: GROUP_LABELS[group.group],
    options: group.message_types.map(toOption),
  }));

  return (
    <SelectContainer>
      <Select
        value={decodeFilterOptions(value)}
        isMulti={true}
        isLoading={isPending}
        theme={useReactSelectTheme()}
        options={options}
        autoFocus={autoFocus}
        onChange={(value: MultiValue<{ value: string }>) => {
          onChange({
            target: { value: value.length > 0 ? JSON.stringify(value) : "" },
          });
        }}
      />
    </SelectContainer>
  );
};

export default MessageTypeSelect;
